export class PPhostedPricing {
  countFrom: number;
  countTo: number;
  costMonthly: number;
  uniqueCost: number;


  constructor() {
    this.countFrom = 0;
    this.countTo = 0;
    this.costMonthly = 0;
    this.uniqueCost = 0;
  }
}



// WEBPACK FOOTER //
// ./src/models/PPhostedPricing.model.ts